import { useEffect } from "react";
import { useResetRecoilState, useSetRecoilState } from "recoil";

import { useToggleAtom } from "../../hooks/useToggleAtom";
import { chatLinkMenuCoord } from "./chatLinkMenuCoord";
import { chatMenuState } from "./chatMenuState";

export const MENU_HEIGHT = 145;

export const useOpenChatChooseMenu = (timeout = 300) => {
  const { open, isOpen, close } = useToggleAtom(chatMenuState);
  const setCoordinates = useSetRecoilState(chatLinkMenuCoord);
  const resetCoords = useResetRecoilState(chatLinkMenuCoord);

  let timerId: number | null = null;

  const openChatMenu = (event: React.MouseEvent) => {
    const target = event.target as Element;
    if (!target) return;

    const rect = target.getBoundingClientRect();

    const left = rect.left;
    const top = rect.top;
    const height = window.innerHeight;

    const topSpace = top - MENU_HEIGHT;
    const bottomSpace = height - top - MENU_HEIGHT;

    const leftCoord = left < 16 ? 16 : left;
    const topCoord = topSpace > bottomSpace ? top : top - MENU_HEIGHT;
    const verticalOrientation = topSpace > bottomSpace ? "top" : "bottom";

    setCoordinates({ leftCoord, topCoord, verticalOrientation });

    open();
  };

  const closeChatMenu = () => {
    timerId = window.setTimeout(() => {
      resetCoords();
    }, timeout);
    close();
  };

  useEffect(() => {
    return () => {
      timerId && clearTimeout(timerId);
    };
  });

  return { openChatMenu, isChatMenuOpen: isOpen, closeChatMenu };
};
